import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import {ConfigService} from './config.service';
import {LogService} from './log.service';


@Injectable()
export class VersionService {
	constructor (
		private http: Http,

		private config: ConfigService,
		private log: LogService
	) {}


	private lastVersionChecked = '';
	private timeLastVersionChecked = 0;

	uiVersion: any = {
		version: '0.0.93',
		gitSha: '37c5667e63073a9d020a21ab7e1b11dee3f34589',
		environment: this.config.environment,
		libVersion: '0.0.9'
	};


	getVersion() {
		return new Promise( (resolve, reject) => {
			this.http.get(this.config.basePath + '/v0/version')
				.subscribe((res) => {
					let result: any = {
						apiVersion: res.json(),
						uiVersion: this.uiVersion
					};
					resolve(result);
				});
		});
	}


	isNewVersion(ver: any): boolean {
		if (ver === this.uiVersion.version) {
			// console.log('isNewVersion, same versions');
			// console.log(`lastVersionChecked = ${this.lastVersionChecked}`);
			// console.log(`timeLastVersionChecked = ${this.timeLastVersionChecked}`);
			return false;
		}

		if (!window.localStorage) {
			console.log('Browser does not support local storage.');
			return false;
		}
		let checkVersionString = localStorage.getItem('check-version');
		if (checkVersionString) {
			let checkVersion = JSON.parse(checkVersionString);
			this.lastVersionChecked = checkVersion.version;
			this.timeLastVersionChecked = checkVersion.modified;
		}

		if (ver !== this.lastVersionChecked) {
			// console.log('isNewVersion, found new version, that has not been checked');
			// console.log(`lastVersionChecked = ${this.lastVersionChecked}`);
			// console.log(`timeLastVersionChecked = ${this.timeLastVersionChecked}`);

			this.lastVersionChecked = ver;
			this.timeLastVersionChecked = Date.now();

			let checkVersion = {
				version: this.lastVersionChecked,
				modified: this.timeLastVersionChecked
			};
			let checkVersionStringz = JSON.stringify(checkVersion);
			localStorage.setItem('check-version', checkVersionStringz);

			return true;
		}

		let isTimeForNextCheck = (Date.now() > (this.timeLastVersionChecked + 60 * 60 * 1000) );
		// let isTimeForNextCheck = (Date.now() > (this.timeLastVersionChecked + 8 * 1000) );
		if (isTimeForNextCheck) {
			this.log.warn('isNewVersion, found new version, that has been checked, time to check again. current ' + this.uiVersion.version + ', new ' + ver);
			// console.log(`lastVersionChecked = ${this.lastVersionChecked}`);
			// console.log(`timeLastVersionChecked = ${this.timeLastVersionChecked}`);
			this.timeLastVersionChecked = Date.now();

			let checkVersion = {
				version: this.lastVersionChecked,
				modified: this.timeLastVersionChecked
			};
			let checkVersionStringx = JSON.stringify(checkVersion);
			localStorage.setItem('check-version', checkVersionStringx);

			return true;
		}

		// console.log('isNewVersion, found new version, that has been checked, wait to check again');
		// console.log(`lastVersionChecked = ${this.lastVersionChecked}`);
		// console.log(`timeLastVersionChecked = ${this.timeLastVersionChecked}`);
		return false;
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/version.service.ts